<ng-template #titleBar>
  Visual
</ng-template>


<p>visual works!</p>
